module.exports = __webpack_public_path__ + "img/SAFo_SocialMedia_DataMining.0c38364e.svg";